// src/pages/DanhGiaCuoiKy/FormCaNam.js
import React, { useState } from "react";
import { useToast } from "../../components/Toast/ToastContext";

const FormCaNam = ({ data, lopId, namHoc, onSave, onClose, canEdit }) => {
  const { success } = useToast();
  const [loading, setLoading] = useState(false);
  const [ketQua, setKetQua] = useState(data?.ketQua || 'lenLop');

  const handleSave = async () => {
    setLoading(true);
    await onSave(data.hocSinhId, {
      hocSinhId: data.hocSinhId,
      lopId,
      hocKy: 'caNam',
      namHoc,
      ketQua,
      trangThai: 'daHoanThanh',
      diemTB: data.dtbCaNam,
      chuyenCan: data.ccCaNam,
      nhanBan: data.nhanBanHK2,
      xepLoai: data.xepLoaiHK2,
      dtbHK1: data.dtbHK1,
      dtbHK2: data.dtbHK2,
      ccHK1: data.ccHK1,
      ccHK2: data.ccHK2,
    });
    setLoading(false);
  };

  return (
    <div className="space-y-4">
      <div className="bg-surface-container-low rounded-xl p-4">
        <h4 className="text-body-md font-bold mb-3">📊 Tổng hợp cả năm</h4>
        <div className="grid grid-cols-2 gap-3 text-body-md">
          <div>
            <p className="text-caption text-on-surface-variant">ĐTB HK1</p>
            <p className="font-bold text-lg">{data.dtbHK1 || '—'}</p>
          </div>
          <div>
            <p className="text-caption text-on-surface-variant">ĐTB HK2</p>
            <p className="font-bold text-lg">{data.dtbHK2 || '—'}</p>
          </div>
          <div>
            <p className="text-caption text-on-surface-variant">ĐTB Cả năm</p>
            <p className="font-bold text-lg text-primary">{data.dtbCaNam || '—'}</p>
          </div>
          <div>
            <p className="text-caption text-on-surface-variant">Chuyên cần</p>
            <p className="font-bold text-lg">{data.ccCaNam}%</p>
          </div>
          <div>
            <p className="text-caption text-on-surface-variant">Nhân bản HK2</p>
            <p className="font-bold">{data.nhanBanHK2 || '—'}</p>
          </div>
          <div>
            <p className="text-caption text-on-surface-variant">Xếp loại HK2</p>
            <p className="font-bold">{data.xepLoaiHK2 || '—'}</p>
          </div>
        </div>
      </div>

      {!data.daCoDuLieu && (
        <div className="p-3 bg-yellow-50 text-yellow-700 rounded-xl text-body-md">⚠️ Chưa có đủ đánh giá HK1 và HK2</div>
      )}

      <div>
        <label className="text-label-caps font-bold text-on-surface-variant block mb-1">Kết quả cả năm *</label>
        <div className="flex gap-2">
          <button onClick={() => setKetQua('lenLop')}
            className={`flex-1 py-3 rounded-xl font-bold text-body-md transition-all ${ketQua === 'lenLop' ? 'bg-green-500 text-white shadow-lg' : 'bg-surface border border-outline-variant'}`}>
            ✅ Lên lớp
          </button>
          <button onClick={() => setKetQua('luuBan')}
            className={`flex-1 py-3 rounded-xl font-bold text-body-md transition-all ${ketQua === 'luuBan' ? 'bg-red-500 text-white shadow-lg' : 'bg-surface border border-outline-variant'}`}>
            ❌ Lưu ban
          </button>
        </div>
      </div>

      {canEdit && (
        <div className="flex gap-2 pt-2 border-t border-outline-variant">
          <button onClick={onClose} className="flex-1 py-2.5 bg-surface border border-outline-variant rounded-xl text-body-md font-semibold">Hủy</button>
          <button onClick={handleSave} disabled={loading} className="flex-1 py-2.5 bg-primary text-on-primary rounded-xl text-body-md font-semibold">{loading ? '⏳...' : '✅ Lưu kết quả'}</button>
        </div>
      )}
    </div>
  );
};

export default FormCaNam;